import { sendRequest } from 'api/sendRequest';
import { OneOnOneRequestI } from 'screens/oneOnOneRabbit/interfaces/common';

import { endpoints } from 'constants/endpoints';

import { LibraryTypeI } from '../interface';

export const getOneOnOneAgendaLibraryApi = ({ masterId, instanceId, type }: OneOnOneRequestI & LibraryTypeI) => {
  const url = endpoints.oneOnOneRevamped.agendaLibrary(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      instanceId,
      type,
    },
  });
};

export const addAgendaFromLibraryToInstanceApi = ({
  masterId,
  instanceId,
  libraryAgendaId,
  agendaText,
}: OneOnOneRequestI & { libraryAgendaId: number; agendaText: string }) => {
  const url = endpoints.oneOnOneRevamped.addAgendaFromLibrary(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      instanceId,
    },
    body: {
      libraryAgendaId,
      agendaText,
    },
  });
};

export const getOneOnOneAgendaLibraryForSettingsApi = ({ type }: LibraryTypeI) => {
  const url = endpoints.oneOnOneRevamped.agendaLibraryForSettings;
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      type,
    },
  });
};
